module.exports = __webpack_public_path__ + "static/media/success-icon.d0c2cfff.svg";